import Swiper from 'swiper/js/swiper.min';

class MultiSlider {
    constructor(options) {
        this.item = options.item;
        this.slider = null;
        this.settings = options.settings;
    }

    init() {
        this.slider = new Swiper(this.item, this.settings);
    }
}

export default MultiSlider;
